import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit
} from '@angular/core';
import { Store } from '@ngrx/store';

import { ENVIRONMENT_CONFIG, storageKeys } from '@ui/landlord/shared/config';
import {
  LocalStorageService,
  StopCountUnreadPolling,
  StopFindUnreadMessagesPolling,
  UserLogout
} from '@ui/legacy-lib';
import { ChatWidgetService } from 'landlord/main';

@Component({
  selector: 'app-logout',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoutComponent implements OnInit {
  #chatWidgetService = inject(ChatWidgetService, { optional: true });
  private store = inject(Store);
  private environment = inject(ENVIRONMENT_CONFIG);
  private storageService = inject(LocalStorageService);

  ngOnInit() {
    const redirectUri = this.environment.landlord_home_url;
    this.store.dispatch(new StopCountUnreadPolling());
    this.store.dispatch(new StopFindUnreadMessagesPolling());
    this.store.dispatch(new UserLogout(redirectUri));
    this.storageService.removeItem(storageKeys.dashboardAgent);
    this.#chatWidgetService?.logout?.();
  }
}
